import { useContext } from "react";
import { AppContext } from "../App";
import { FiAward, FiTarget, FiActivity, FiUsers } from "react-icons/fi";

export default function SpecializedClinics() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiAward />,
      title: "Care & Treatment Clinic (CTC Program)",
      desc: "Comprehensive HIV/AIDS management models covering ART initiation, viral load tracking, PMTCT support systems, opportunistic infection care, and counseling."
    },
    {
      icon: <FiTarget />,
      title: "Occupational Health Services Clinic",
      desc: "Pre-employment medical clearance, annual fitness-for-duty screening matrixes, work-injury management plans, and official medical fitness certificate issuance."
    },
    {
      icon: <FiActivity />,
      title: "Nutrition & Dietetics Clinic",
      desc: "Clinical nutritionist-led therapeutic meal modeling and systematic dietary assessments for vulnerable populations, pediatric malnutrition, and metabolic comorbidities."
    },
    {
      icon: <FiUsers />,
      title: "Adolescent Friendly Health Clinic",
      desc: "Confidential consultations for ages 10–19 bridging physical wellness, mental health, reproductive safety parameters, sports fitness, and school clearances."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <h2 className="pillar-title">Specialized Clinics</h2>
        <p className="pillar-subtitle">Targeted healthcare delivery architectures tailored for specialized or high-vulnerability patient cohorts.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}